import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule, FreudCardModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactBulkMessageModule } from '../contact-bulk-message/contact-bulk-message.module';
import { ContactBulkActionsComponent } from './contact-bulk-actions.component';

@NgModule({
	declarations: [ContactBulkActionsComponent],
	imports: [
		CommonModule,
		FreudCardModule,
		FreudButtonModule,
		ContactBulkMessageModule,
		TranslateModule,
	],
	exports: [ContactBulkActionsComponent],
})
export class ContactBulkActionsModule {}
